import React from 'react';

class BrightCove extends React.Component {


    render() {
        let { src, width='430', height='320', style } = this.props;
        return (
           <div className='brightcove-container' style={{position:'relative',width: '100%'}}>
               <iframe
               frameBorder="0"
               allowFullScreen=""
               className="brightcove-iframe"
               src={src}
               style={style}
               width={width} height={height}></iframe>
           </div>
        );
    }
}

export default BrightCove;
